import React, { useRef } from "react";
import { motion } from "framer-motion";
import MagicParticles from "../index/MagicParticles";
//import SimpleBar from 'simplebar-react';
//import 'simplebar-react/dist/simplebar.min.css';
import Header from "../index/Header";
import Footer from "../index/Footer";
import PildorasServices from "./PildorasServices";
import {
  BookOpen,
  Coffee,
  Bookmark,
  PenTool,
  Sparkles,
  Theater,
  Landmark,
  Music2,
  Camera,
  Utensils,
  Shirt,
  Brush,
  ScrollText,
  Gift
  
} from "lucide-react";


const servicios = [
  {
    title: "Presentaciones de libros",
    desc: "Escenarios inmersivos para presentar obras de forma teatralizada.",
    icon: <BookOpen className="w-8 h-8 text-eryndra-gold mb-4 group-hover:text-eryndra-forest" />,
  },
  {
    title: "Meriendas literarias",
    desc: "Reuniones íntimas entre lectoras, autoras y universos compartidos.",
    icon: <Coffee className="w-8 h-8 text-eryndra-gold mb-4 group-hover:text-eryndra-forest" />,
  },
  {
    title: "Clubes de lectura temáticos",
    desc: "Basados en sagas, géneros o autoras, en entornos únicos.",
    icon: <Bookmark className="w-8 h-8 text-eryndra-gold mb-4 group-hover:text-eryndra-forest" />,
  },
  {
    title: "Encuentros con autoras",
    desc: "Firmas, charlas, coloquios y experiencias literarias cercanas.",
    icon: <PenTool className="w-8 h-8 text-eryndra-gold mb-4 group-hover:text-eryndra-forest" />,
  },
  {
    title: "Eventos temáticos de sagas",
    desc: "Inspirados en mundos como ACOTAR, Bridgerton, Grishaverse...",
    icon: <Sparkles className="w-8 h-8 text-eryndra-gold mb-4 group-hover:text-eryndra-forest" />,
  },
  {
    title: "Lecturas teatralizadas",
    desc: "Escenificaciones de capítulos o cuentos con actores o lectoras.",
    icon: <Theater className="w-8 h-8 text-eryndra-gold mb-4 group-hover:text-eryndra-forest" />,
  },
];

const cards = [
  {
    title: "Escenografía personalizada",
    desc: "Decorado ambientado en la saga o universo elegido.",
    icon: <Landmark className="w-6 h-6 text-eryndra-gold mt-1" />,
  },
  {
    title: "Microfonía y música",
    desc: "Sonido e hilo musical inmersivo.",
    icon: <Music2 className="w-6 h-6 text-eryndra-gold mt-1" />,
  },
  {
    title: "Fotografía profesional",
    desc: "Captura de cada instante mágico.",
    icon: <Camera className="w-6 h-6 text-eryndra-gold mt-1" />,
  },
  {
    title: "Catering temático",
    desc: "Comida y bebida inspiradas en el universo del evento.",
    icon: <Utensils className="w-6 h-6 text-eryndra-gold mt-1" />,
  },
  {
    title: "Narración teatralizada",
    desc: "Lecturas y escenificaciones únicas.",
    icon: <Theater className="w-6 h-6 text-eryndra-gold mt-1" />,
  },
  {
    title: "Vestuario personalizado",
    desc: "Diseño o alquiler de vestuario a juego.",
    icon: <Shirt className="w-6 h-6 text-eryndra-gold mt-1" />,
  },
  {
      title: "Material promocional",
      desc: "Material promocional para autoras/editoriales.",
      icon: <ScrollText className="w-6 h-6 text-eryndra-gold mt-1" />,
    },
    {
      title: "Detalles para participantes",
      desc: "Detalles para participantes o lectoras.",
      icon: <Gift className="w-6 h-6 text-eryndra-gold mt-1" />,
    },
];

export default function LiteraryEvents() {
  const scrollRef = useRef();
  return (
    //<SimpleBar ref={scrollRef} style={{ maxHeight: '100vh' }} autoHide={false}>
      <main className="font-cinzel bg-eryndra-forest text-eryndra-cream relative ">
      <div className="absolute inset-0 z-20 pointer-events-none">
        <MagicParticles />
      </div>
    <section className="relative bg-eryndra-forest text-eryndra-cream">
      
       <Header scrollRef={scrollRef} backgroundColor="bg-eryndra-forest/20" />
      {/* Hero Section */}
      <motion.section className="relative bg-eryndra-libro bg-cover bg-center text-center py-80"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}>
                    <h1 className="font-title text-5xl md:text-8xl  mb-4  tracking-widest text-shadow-lg">eVeNTOS liTeRARiOS</h1>
                    <p className="text-lg md:text-2xl px-2 text-shadow-DEFAULT">
                    Donde las palabras cobran vida y los libros se convierten en experiencias.
                    </p>
                </motion.section>
                <div className="py-24 px-16 md:px-32 lg:px-80 relative z-10">
  <h2 className="text-4xl md:text-5xl font-cinzel text-eryndra-gold text-center uppercase mb-16">
    Nuestros Servicios Literarios
  </h2>

  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
    {servicios.map((item, i) => (
      <div
        key={i}
        className="group bg-eryndra-ivory/5 backdrop-blur-md p-6 border border-eryndra-gold rounded-xl transition-transform duration-300 transform hover:scale-105 hover:bg-eryndra-gold"
      >
        <div className="flex flex-col items-center text-center ">
          {item.icon}
          <h3 className="text-eryndra-gold font-bold font-cinzel text-xl uppercase mb-2 group-hover:text-eryndra-forest ">
            {item.title}
          </h3>
          <p className="font-bellefair text-xl leading-relaxed group-hover:text-eryndra-forest ">
            {item.desc}
          </p>
        </div>
      </div>
    ))}
  </div>
</div>

      


</section>
      {/* ¿Qué incluye? */}
      <section className="py-20 px-6 md:px-16 lg:px-48 text-center bg-eryndra-ivory/10 ">
  <h2 className="text-4xl md:text-5xl text-eryndra-gold font-cinzel uppercase mb-12">
    ¿Qué incluye un evento literario de Eryndra?
  </h2>
  <p className="font-bellefair text-xl md:text-xl mb-12 text-eryndra-cream">
          Cada evento está diseñado para que vivas una experiencia completa de fantasía. Estos son los elementos que hacen que nuestros eventos sean inolvidables:
        </p>

  <div className=" grid grid-cols-1 sm:grid-cols-2 gap-10 text-left max-w-5xl mx-auto">
    {cards.map((card, i) => (
            <div key={i} className="flex items-start gap-4">
              {card.icon}
              <div>
                <h4 className="font-bold text-xl text-eryndra-gold font-cinzel">
                  {card.title}
                </h4>
                <p className="font-bellefair text-lg text-eryndra-cream">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
      
    </div>
</section>

<section className="  bg-[url('/public/img/pergamino-textura.png')] bg-center bg-cover text-eryndra-forest py-10 px-6 text-center ">
      {/* Call to Action */}
      
      <div className="text-center py-16">
      <h3 className="text-3xl font-bold md:text-4xl font-cinzel text-eryndra-forest mb-6 ">Queremos hacer ese sueño realidad</h3>
        <p className="text-2xl font-bellefair mb-4">
          ¿Tienes un libro que merece una presentación mágica? ¿Un encuentro inolvidable?
        </p>
        <div className="mt-6">
                        <a href="/contactanos" className="btn-eryndra-forest">
                            Solicita tu evento
                        </a>
                    </div>
      </div>
    </section>
    <Footer/>
    </main>
    //</SimpleBar>
  );
}
